import React from 'react';
import MessageBox from '../../generic-components/message-box';
import EmailToPartners from '../../generic-components/email-to-partners';
import { FontIcon, Checkbox, CircularProgress, RaisedButton, TextField } from 'material-ui';
import SuccessPage from '../success-page';
import R from 'ramda';
import GroupTemplateIcon from 'material-ui/svg-icons/content/link';
import pluralize from 'pluralize';
const isNilOrEmpty = R.either(R.isNil, R.isEmpty);

class ReviewAndSend extends React.Component {
  constructor() {
    super();
    this.state = {
      showAllInReview: false,
    };
  }
  render() {
    const { partners, sendingContracts, updateProps, templateSelected, templateGroupSelected, sentPartnersLength, message, subject, bccSelf, contractsSent } = this.props;
    const contractsToBeCreated = isNilOrEmpty(templateGroupSelected) ? sentPartnersLength : R.pathOr(0, ['templates', 'length'], templateGroupSelected) * sentPartnersLength;
    if (sendingContracts) {
      return (
        <div style={{ textAlign: 'center' }}>
          <CircularProgress size={120} />
          <p style={{ fontSize: '16px', margin: '32px' }}>
            We are processing your request, thanks for your patience!
          </p>
        </div>
      );
    }
    if (contractsSent && contractsToBeCreated > 100) {
      return (
        <div style={{ textAlign: 'center' }}>
          <p style={{ fontSize: '16px', margin: '32px' }}>
            We are processing your request. Due to the large number of contracts, this may take a little while. Feel free to continue working in the system.
          </p>
          <RaisedButton
            secondary
            style={{ margin: '24px auto' }}
            label="Go to My Contract List"
            onTouchTap={() => this.context.router.push('/contracting/contract-list/all%20contracts')}
          />
        </div>
      );
    }
    if (contractsSent && contractsToBeCreated < 101) {
      return (
        <SuccessPage
          contractsToBeCreated={contractsToBeCreated}
          sentPartnersLength={sentPartnersLength}
        />
      );
    }
    const labelStyle = { width: '70%', color: 'rgba(0, 0, 0, 0.64)', marginRight: '40px' };
    return (
      <div>
        <div style={{ borderBottom: '1px solid #e0e0e0', lineHeight: '32px', marginBottom: '20px', fontWeight: 'bold' }}>
          Organize Buyers and Contracts
        </div>
        <div style={{ paddingLeft: '16px' }}>
          <Checkbox
            labelStyle={labelStyle}
            style={{ marginBottom: '16px' }}
            label={`Assign a tag to ${pluralize('buyers', partners.length)}`}
            onCheck={(_, inputChecked) => updateProps({ assignTag: inputChecked })}
          />
          {
            Boolean(this.props.assignTag) && (
              <div style={{ marginBottom: '16px' }}>
                <div style={{ ...labelStyle, fontSize: '12px' }}>To assign a tag to these {pluralize('buyer', partners.length)} in the Connections enter the tag name below</div>
                <TextField
                  style={{ width: '40%' }}
                  hintText="Enter tag name here..."
                  onChange={(_, value) => updateProps({ tags: [value] })}
                />
              </div>
            )
          }
          <Checkbox
            labelStyle={labelStyle}
            style={{ marginBottom: '16px' }}
            label={`Assign ${pluralize('contracts', partners.length)} to a folder`}
            onCheck={(_, inputChecked) => updateProps({ assignFolder: inputChecked })}
          />
          {
            Boolean(this.props.assignFolder) && (
              <div style={{ marginBottom: '16px' }}>
                <div style={{ ...labelStyle, fontSize: '12px' }}>To assign these {pluralize('contracts', partners.length)} to a folder in the Contract List enter the folder name below</div>
                <TextField
                  style={{ width: '40%' }}
                  hintText="Enter folder name here..."
                  onChange={(_, value) => updateProps({ folders: [value] })}
                />
              </div>
            )
          }
        </div>
        <div style={{ borderBottom: '1px solid #e0e0e0', lineHeight: '32px', marginBottom: '20px', fontWeight: 'bold' }}>
          Review & Send
        </div>
        <div style={{ paddingLeft: '16px' }}>
          {
            /*
             <EmailToPartners
             partners={partners}
             defaultShowNumOfPartners={8}
             />
             */
          }
          <Checkbox
            checked={bccSelf}
            onCheck={() => updateProps({ bccSelf: !bccSelf })}
            label="Send a Copy to yourself"
            labelStyle={{ color: 'rgba(0, 0, 0, 0.64)' }}
            style={{ width: '250px', margin: '8px 0' }}
          />
          <label style={{ fontSize: '14px' }}>Subject:</label>
          <br/>
          <input
            value={subject}
            autoFocus
            onChange={({ target: { value } }) => updateProps({ subject: value })}
            style={{ width: '100%', height: '32px' }}
          />
          <div style={{ fontSize: '14px', margin: '12px 8px 24px 0', color: '#616161' }}>
            <label>Custom Message: </label>
            <br/>
            <MessageBox
              value={message}
              onChange={(value) => updateProps({ message: value })}
            />
            <br/>
            <div>
              Send your partner a nice message with your rates, above. Be sure to include any important information about your rates. For example:
              <br/>
              - Are your rates the same as last year or did they change?
              <br/>
              - How much did they change?
              <br/>
              - Did any of your key policies change?
            </div>
          </div>
          {/*<span>Included Templates: </span>*/}
          {
            // !isNilOrEmpty(templateGroupSelected) ? (
            //   <div>
            //     <div style={{ display: 'flex', alignItems: 'center', color: 'rgba(0, 0, 0, 0.54)' }}>
            //       <GroupTemplateIcon color="rgba(0, 0, 0, 0.54)"/>{templateGroupSelected.groupName}
            //     </div>
            //     <div>
            //       {
            //         R.propOr([], 'templates', templateGroupSelected)
            //           .filter((_, i, arr) => (arr.length < 16 || this.state.showAllInReview) || i < 16)
            //           .map(({ locationName, templateName }, i) => (
            //             <div key={i} style={{ display: 'flex', alignItems: 'center', color: 'rgba(0, 0, 0, 0.54)', fontStyle: 'italic' }}>
            //               <FontIcon className="tc-icon-description" color="rgba(0, 0, 0, 0.54)" />
            //               {locationName}
            //               <small style={{ paddingLeft: '2px' }}>({templateName})</small>
            //             </div>))
            //       }
            //       {
            //         R.pathOr([], ['templates', 'length'], templateGroupSelected) > 15 ? (
            //           <div
            //             style={{ lineHeight: '48px', color: '#00bcd4', cursor: 'pointer' }}
            //             onClick={() => this.setState({ showAllInReview: !this.state.showAllInReview })}
            //           >
            //             {this.state.showAllInReview ? 'Show Less' : 'Show All'}
            //           </div>
            //         ) : <div/>
            //       }
            //     </div>
            //   </div>
            // ) : (
            //   <div style={{ display: 'flex', alignItems: 'center', color: 'rgba(0, 0, 0, 0.54)', fontStyle: 'italic' }}>
            //     <FontIcon className="tc-icon-description" color="rgba(0, 0, 0, 0.54)" />
            //     {templateSelected.locationName}
            //     <small style={{ paddingLeft: '2px' }}>({templateSelected.templateName})</small>
            //   </div>
            // )
          }
        </div>
      </div>
    );
  }
}
ReviewAndSend.contextTypes = {
  router: React.PropTypes.object.isRequired,
};
export default ReviewAndSend;



// WEBPACK FOOTER //
// ./src/app/components/contracting/supplier-wizard/supplier-initiated/review-send.jsx